import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const OccurrenceBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open } = useCommands();
    const {
        selectedOccurrenceCount = 0,
        onOccurrenceBulkApply,
        onOccurrenceBulkSkip,
        onOccurrenceBulkUnskip,
        onOccurrenceBulkDelete,
        occurrenceBulkPreparerOptions,
        occurrenceBulkReviewerOptions,
        occurrenceBulkManagerOptions,
        occurrenceBulkClientOptions,
    } = options;

    const heading = `${selectedOccurrenceCount} ${pluralize("occurrence", selectedOccurrenceCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onOccurrenceBulkApply && (
                <CommandItem
                    keywords={["apply", "apply now"]}
                    onSelect={onOccurrenceBulkApply}
                >
                    Apply
                </CommandItem>
            )}
            {onOccurrenceBulkSkip && (
                <CommandItem
                    keywords={["skip"]}
                    onSelect={onOccurrenceBulkSkip}
                >
                    Skip
                </CommandItem>
            )}
            {onOccurrenceBulkUnskip && (
                <CommandItem
                    keywords={["schedule", "unskip", "undo skip"]}
                    onSelect={onOccurrenceBulkUnskip}
                >
                    Schedule
                </CommandItem>
            )}
            {occurrenceBulkPreparerOptions && (
                <CommandItem
                    keywords={["preparer", "assign preparer", "set preparer"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.OCCURRENCE_BULK_PREPARER,
                            options,
                        )
                    }
                >
                    Set preparer
                </CommandItem>
            )}
            {occurrenceBulkReviewerOptions && (
                <CommandItem
                    keywords={["reviewer", "assign reviewer", "set reviewer"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.OCCURRENCE_BULK_REVIEWER,
                            options,
                        )
                    }
                >
                    Set reviewer
                </CommandItem>
            )}
            {occurrenceBulkManagerOptions && (
                <CommandItem
                    keywords={["manager", "assign manager", "set manager"]}
                    onSelect={() =>
                        open(CommandsDirectory.OCCURRENCE_BULK_MANAGER, options)
                    }
                >
                    Set manager
                </CommandItem>
            )}
            {occurrenceBulkClientOptions && (
                <CommandItem
                    keywords={["client", "assign client", "set client"]}
                    onSelect={() =>
                        open(CommandsDirectory.OCCURRENCE_BULK_CLIENT, options)
                    }
                >
                    Set client
                </CommandItem>
            )}
            {onOccurrenceBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove"]}
                    shortcut="delete"
                    onSelect={onOccurrenceBulkDelete}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
